import { useEffect } from "react";
import {
  defaultSiteDescription,
  defaultSiteTitle,
  socialPreviewUrl,
  siteName,
  siteUrl,
} from "../data/siteMeta";

function updateMetaByName(name, content) {
  const metaTag = document.querySelector(`meta[name="${name}"]`);

  if (metaTag) {
    metaTag.setAttribute("content", content);
  }
}

function updateMetaByProperty(property, content) {
  const metaTag = document.querySelector(`meta[property="${property}"]`);

  if (metaTag) {
    metaTag.setAttribute("content", content);
  }
}

function updateMetaByItemProp(itemProp, content) {
  const metaTag = document.querySelector(`meta[itemprop="${itemProp}"]`);

  if (metaTag) {
    metaTag.setAttribute("content", content);
  }
}

function updateCanonicalUrl(absoluteUrl) {
  const canonicalLink = document.querySelector('link[rel="canonical"]');

  if (canonicalLink) {
    canonicalLink.setAttribute("href", absoluteUrl);
  }
}

function updateStructuredData(title, description, absoluteUrl) {
  const existingScript = document.getElementById("page-schema");

  if (!existingScript) {
    return;
  }

  existingScript.textContent = JSON.stringify(
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: title,
      description,
      url: absoluteUrl,
      isPartOf: {
        "@type": "WebSite",
        name: siteName,
        url: siteUrl,
      },
    },
    null,
    2
  );
}

function usePageMeta(title = defaultSiteTitle, description = defaultSiteDescription) {
  useEffect(() => {
    const currentUrl = new URL(window.location.pathname, siteUrl);
    const absoluteUrl = currentUrl.toString();

    document.title = title;

    updateMetaByName("description", description);
    updateMetaByName("twitter:image", socialPreviewUrl);
    updateMetaByName("twitter:image:alt", `${siteName} portfolio preview`);
    updateMetaByName("twitter:title", title);
    updateMetaByName("twitter:description", description);
    updateMetaByProperty("og:site_name", siteName);
    updateMetaByProperty("og:title", title);
    updateMetaByProperty("og:description", description);
    updateMetaByProperty("og:url", absoluteUrl);
    updateMetaByProperty("og:image", socialPreviewUrl);
    updateMetaByProperty("og:image:alt", `${siteName} portfolio preview`);
    updateMetaByItemProp("name", title);
    updateMetaByItemProp("description", description);
    updateMetaByItemProp("image", socialPreviewUrl);
    updateCanonicalUrl(absoluteUrl);
    updateStructuredData(title, description, absoluteUrl);
  }, [description, title]);
}

export default usePageMeta;